import { gql } from '@apollo/client';

export const GENERATE_FINGERPRINT = gql`
  mutation GenerateFingerprint {
    generateFingerprint
  }
`; 